/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Too_Little_Said_TitleInputs */



/**
* | output |
* | --- |
* | "Too little was said for a report" |
*
* @param {Meeting_Notetaker_Issue_Too_Little_Said_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_too_little_said_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Too_Little_Said_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Too_Little_Said_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er werd te weinig gezegd voor een verslag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trop peu a été dit pour un compte rendu")
	return /** @type {LocalizedString} */ ("Too little was said for a report")
});